import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, map, tap } from 'rxjs/operators';

import { ProgramPeriod } from '@assess/browser/api';
import { trackByFunctions } from '@assess/browser/track-by-functions';

@UntilDestroy()
@Component({
  selector: 'assess-query-input-period-selector',
  templateUrl: './query-input-period-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueryInputPeriodSelectorComponent implements OnInit, OnChanges {
  @Input() period: string | undefined | null;
  @Input() periods!: ProgramPeriod[] | undefined | null;
  @Input() queryValue!: string | undefined | null;
  @Output() queryChange = new EventEmitter();
  @Output() periodChange = new EventEmitter();

  readonly debounceTime = 500;
  readonly programPeriod = new FormControl();
  readonly query = new FormControl();
  readonly trackBy = trackByFunctions.byId;

  ngOnInit(): void {
    this.programPeriod.patchValue(this.period, { emitEvent: false });
    this.query.patchValue(this.queryValue, { emitEvent: false });
    this.subscribeToChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.period?.currentValue) {
      this.programPeriod.patchValue(changes.period?.currentValue, { emitEvent: false });
    }

    if (changes.queryValue?.currentValue) {
      this.query.patchValue(changes.queryValue?.currentValue, { emitEvent: false });
    }
  }

  private subscribeToChanges() {
    this.query.valueChanges
      .pipe(
        untilDestroyed(this),
        debounceTime(this.debounceTime),
        tap((query) => {
          this.queryChange.next(query);
        })
      )
      .subscribe();

    this.programPeriod.valueChanges
      .pipe(
        untilDestroyed(this),
        filter(() => !!(this.periods || [])?.length),
        map((periodId) => (this.periods || []).find((p) => p.id === periodId)),
        tap((period) => this.periodChange.next(period))
      )
      .subscribe();
  }
}
